import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReportsComponent } from './reports/reports.component';
import { LeadsComponent } from './leads/leads.component';
import { MissingrecordingsComponent } from './missingrecordings/missingrecordings.component';
import { SpecsComponent } from './specs/specs.component';
import { UnapprovedsourcesComponent } from './unapprovedsources/unapprovedsources.component';
import { NavbarComponent } from './navbar/navbar.component';
import { LoginService } from './services/login.service';
import { HttpClientModule } from '@angular/common/http';
import { RegisterComponent } from './register/register.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { MatPaginator, MatTableDataSource, MatTableModule, MatInputModule, MatLabel, MatPaginatorModule, MatSortModule, MatDatepickerModule } from '@angular/material';
import {  OwlDateTimeModule,  OwlNativeDateTimeModule} from 'ng-pick-datetime';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { RecaptchaModule } from 'ng-recaptcha';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    ReportsComponent,
    LeadsComponent,
    MissingrecordingsComponent,
    SpecsComponent,
    UnapprovedsourcesComponent,
    NavbarComponent,
    RegisterComponent,
    PasswordresetComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ReactiveFormsModule,
    RecaptchaModule

  ],
  providers: [LoginService, Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
